import { useEffect, useState } from "react";
import ConfirmModal from "../../../Containers/Modals/ConfirmModal";

export function ProductConfirmation({ product, commonActions, orderActions }) {

    const [confirmation, setConfirmation] = useState(null);

    useEffect(() => {
        if (['ADM02', 'ADM05', 'LÖN300'].includes(product.productNumber))
            setConfirmation({
                onConfirmed: () => { setConfirmation(null) },
                onCancel: () => orderActions.hideProductDetails(),
                confirmTitle: `Ingen nyförsäljning gäller för ${product.productDescription}!`,
                confirmTextElement: <p>Gäller ej om kunden haft ett avtal de senaste 15 månaderna</p>,
            })

        commonActions.showModal(true);
    }, [product.productNumber]);


    return confirmation && <ConfirmModal {...confirmation} />
}